<div style="margin-left: 4%; margin-right: 4%;">
  <div style="margin-top: 1.875rem">
    <span class="chargingProjectHeader">My Gas Project Setups</span>
  </div>
</div>
<div style="border-bottom: 0.188rem solid #b7b9ba; margin-top: 2.5rem; width: 88.3%;"></div>
<div style="width: 7.6723%; margin-top: -1rem; padding-left: 5.75%; background: #ffffff; text-align: left;">
  <span style="font-size: 1.125rem; color: #00779d;">IN PROCESS</span>
</div>
<div style="text-align: center">
  <div style="display: inline-block; width: 6.2221%; text-align: center; margin-right: 4.877%;">
    <span class="listHeaderText">Business Unit</span>
  </div>
  <div style="display: inline-block; width: 7.8679%; text-align: center; margin-right: 5.9173%;">
    <span class="listHeaderText">Funding Project ID</span>
  </div>
  <div style="display: inline-block; width: 9.0174%; text-align: center; margin-right: 6.0473%;">
    <div>
      <span class="listHeaderText">(Pending)</span>
    </div>
    <div>
      <span class="listHeaderText">Charging Project ID</span>
    </div>
  </div>
  <div style="display: inline-block; width: 26.8536%; text-align: left;">
    <span class="listHeaderText">Charging Project Name</span>
  </div>
  <div style="display: inline-block; width: 10.4031%; text-align: center;">
    <span class="listHeaderText">Last Saved</span>
  </div>
</div>
<div style="border-bottom: 0.063rem solid #d7d9da; padding-top: 0.313rem; width: 78%; margin: auto;"></div>
<div *ngFor="let setup of inProcessProjectSetups" class="inProcessOption">
  <div style="display: inline-block; width: 6.2221%; text-align: center; margin-right: 4.877%;">
    <span class="listContentText">{{setup.businessUnit}}</span>
  </div>
  <div style="display: inline-block; width: 7.8679%; text-align: center; margin-right: 5.9173%;">
    <span class="listContentText">{{setup.fundingProjectID}}</span>
  </div>
  <div style="display: inline-block; width: 9.0174%; text-align: center; margin-right: 6.0473%;">
    <span class="listContentText">{{setup.chargingProjectID}}</span>
  </div>
  <div style="display: inline-block; width: 24.8536%; text-align: left;">
    <span class="listContentText">{{setup.chargingProjectName}}</span>
  </div>
  <div style="display: inline-block; width: 10.4031%; text-align: right; padding-right: 2%">
    <span class="listContentText">{{formatDate(setup.lastSavedDate)}}</span>
  </div>
  <div style="display: inline-block">
    <img src="assets/trash-bin.svg" style="width: 0.75rem">
  </div>
  <div style="border-bottom: 0.063rem solid #d7d9da; padding-top: 0.625rem; width: 78%; margin: auto;"></div>
</div>
<div style="border-bottom: 0.188rem solid #b7b9ba; margin-top: 2.5rem; width: 88.3%;"></div>
<div style="width: 12.6723%; margin-top: -1rem; padding-left: 5.75%; background: #ffffff; text-align: left;">
  <span style="font-size: 1.125rem; color: #00779d;">SENT TO POWERPLAN</span>
</div>
<div style="text-align: center">
  <div style="display: inline-block; width: 6.2221%; text-align: center; margin-right: 4.877%;">
    <span class="listHeaderText">Business Unit</span>
  </div>
  <div style="display: inline-block; width: 7.8679%; text-align: center; margin-right: 5.9173%;">
    <span class="listHeaderText">Funding Project ID</span>
  </div>
  <div style="display: inline-block; width: 9.0174%; text-align: center; margin-right: 6.0473%;">
    <div>
      <span class="listHeaderText">(Pending)</span>
    </div>
    <div>
      <span class="listHeaderText">Charging Project ID</span>
    </div>
  </div>
  <div style="display: inline-block; width: 26.8536%; text-align: left;">
    <span class="listHeaderText">Charging Project Name</span>
  </div>
  <div style="display: inline-block; width: 10.4031%; text-align: center;">
    <span class="listHeaderText">Sent to PowerPlan</span>
  </div>
</div>
<div style="border-bottom: 0.063rem solid #d7d9da; padding-top: 0.313rem; width: 78%; margin: auto;"></div>
<div *ngFor="let setup of powerPlanProjectSetups" style="text-align: center; padding-top: 0.625rem;">
  <div style="display: inline-block; width: 6.2221%; text-align: center; margin-right: 4.877%;">
    <span class="listContentText">{{setup.businessUnit}}</span>
  </div>
  <div style="display: inline-block; width: 7.8679%; text-align: center; margin-right: 5.9173%;">
    <span class="listContentText">{{setup.fundingProjectID}}</span>
  </div>
  <div style="display: inline-block; width: 9.0174%; text-align: center; margin-right: 6.0473%;">
    <span class="listContentText">{{setup.chargingProjectID}}</span>
  </div>
  <div style="display: inline-block; width: 24.8536%; text-align: left;">
    <span class="listContentText">{{setup.chargingProjectName}}</span>
  </div>
  <div style="display: inline-block; width: 10.4031%; text-align: right; padding-right: 2%;">
    <span class="listContentText">{{formatDate(setup.lastSavedDate)}}</span>
  </div>
  <div style="border-bottom: 0.063rem solid #d7d9da; padding-top: 0.625rem; width: 78%; margin: auto;"></div>
</div>